import sample_1 from './gastro_1.jpg';
import sample_2 from './gastro_2.jpg';
import sample_3 from './gastro_3.jpg';
import sample_4 from './gastro_4.jpg';
import sample_5 from './gastro_5.jpg';

export const gastroImpressions = {
    sample_1,
    sample_2,
    sample_3,
    sample_4,
    sample_5
};
